/**
 * Returns a shallow copy of the object without falsy values.
 *
 * Falsy values are: false, 0, "", null, undefined, NaN.
 * Note: Arrays and objects are truthy even if empty.
 */
export const compactObject = <T extends Record<string, unknown>>(obj: T): Partial<T> => {
  const result: Partial<T> = {};

  Object.entries(obj).forEach(([key, value]) => {
    if (value) {
      result[key as keyof T] = value as T[keyof T];
    }
  });

  return result;
};


